/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkstitle2Inputs */

const en_downloadlinkstitle2 = /** @type {(inputs: Downloadlinkstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download links`)
};

const de_downloadlinkstitle2 = /** @type {(inputs: Downloadlinkstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download-Links`)
};

/**
* | output |
* | --- |
* | "Download links" |
*
* @param {Downloadlinkstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkstitle2 = /** @type {((inputs?: Downloadlinkstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkstitle2(inputs)
	return de_downloadlinkstitle2(inputs)
});
export { downloadlinkstitle2 as "downloadLinksTitle" }